// Generated from source/ by scripts/generate.ts. Do not edit by hand.
import type { IconData } from "../types.js";

/** Archive (actions). */
const icon: IconData = {
  id: "archive",
  name: "Archive",
  category: "actions",
  styles: {
    rounded: {
      svg: '<path d="M5 22Q4.18 22 3.59 21.41T3 20V8.72Q2.55 8.44 2.28 8.01T2 7V4Q2 3.18 2.59 2.59T4 2H20Q20.82 2 21.41 2.59T22 4V7Q22 7.57 21.72 8.01T21 8.72V20Q21 20.82 20.41 21.41T19 22ZM4 7H20V4H4ZM10 14H14Q14.42 14 14.71 13.71T15 13 14.71 12.29 14 12H10Q9.58 12 9.29 12.29T9 13 9.29 13.71 10 14"/>',
    },
    sharp: { svg: '<path d="M3 22V9H2V2H22V9H21V22ZM4 7H20V4H4ZM9 14H15V12H9Z"/>' },
    outline: {
      svg: '<path d="M5 22Q4.18 22 3.59 21.41T3 20V8.72Q2.55 8.44 2.28 8.01T2 7V4Q2 3.18 2.59 2.59T4 2H20Q20.82 2 21.41 2.59T22 4V7Q22 7.57 21.72 8.01T21 8.72V20Q21 20.82 20.41 21.41T19 22ZM5 9V20H19V9ZM4 7H20V4H4ZM10 14H14Q14.42 14 14.71 13.71T15 13 14.71 12.29 14 12H10Q9.58 12 9.29 12.29T9 13 9.29 13.71 10 14M12 14.5"/>',
    },
    duotone: {
      svg: '<g opacity=".32"><path d="M20.76 2.15L21.41 2.59 21.85 3.24 22 4V7L21.93 7.54 21.72 8.01 21.4 8.41 21 8.72V20L20.85 20.76 20.41 21.41 19.76 21.85 19 22H5L4.24 21.85 3.59 21.41 3.15 20.76 3 20V8.72L2.6 8.4 2.28 8.01 2.08 7.54 2 7V4L2.15 3.24 2.59 2.59 3.24 2.15 4 2H20Z"/></g><path d="M5 22Q4.18 22 3.59 21.41T3 20V8.72Q2.55 8.44 2.28 8.01T2 7V4Q2 3.18 2.59 2.59T4 2H20Q20.82 2 21.41 2.59T22 4V7Q22 7.57 21.72 8.01T21 8.72V20Q21 20.82 20.41 21.41T19 22ZM5 9V20H19V9ZM4 7H20V4H4ZM10 14H14Q14.42 14 14.71 13.71T15 13 14.71 12.29 14 12H10Q9.58 12 9.29 12.29T9 13 9.29 13.71 10 14M12 14.5"/>',
    },
  },
  animation: () => import("../animations/archive.js"),
};

export default icon;
